import axios from "axios";
import Cookies from "js-cookie";
import {toast} from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_BACKEND_API_URL;


export const installmentListApi = async (
    accountNo, projectId
) => {
    let responseData;
    try {
        const token = Cookies.get("accessToken");

        const response = await fetch(`${BASE_URL}api/v1/instalment-plan/get?accountNo=${accountNo}&projectId=${projectId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        responseData = await response.json();
    } catch (error) {
        throw new Error(`Error submitting form: ${error.message}`);
    }

    if (responseData.header.code === 600) {
        return responseData;
    } else {
        toast.error(responseData.body.value);
    }
};

export const CreateInstallment = async (payload) => {
    try {
        const token = Cookies.get("accessToken");

        const response = await axios.post(
            `${BASE_URL}api/v1/instalment-plan/create`,
            payload,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("API Error:", error.response?.data || error.message);
        throw new Error(`Error submitting form: ${error.response?.data?.message || error.message}`);
    }
};


export const CreateEditInstallment = async (payload) => {
    try {
        const token = Cookies.get("accessToken");

        const response = await axios.post(
            `${BASE_URL}api/v1/instalment-plan/create-after-edit`,
            payload,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("API Error:", error.response?.data || error.message);
        throw new Error(`Error submitting form: ${error.response?.data?.message || error.message}`);
    }
};

// export const PreviewInstallment = async (
//     customerID,
//     selectedOrgId,
//     accountNo,
//     numInstallments,
//     advancePayment,
//     firstInstallmentDate,
//     userType
// ) => {
//     try {
//         const token = Cookies.get("accessToken");
//         console.log(
//             customerID,
//             selectedOrgId,
//             accountNo,
//             numInstallments,
//             advancePayment,
//             firstInstallmentDate,
//             userType
//         );

//         const response = await axios.get(`${BASE_URL}api/v1/instalment-plan/preview`, {
//             params: {
//                 accountNo:"28802055",
//                 advanceAmount: 200,
//                 firstInstalmentDate: "2025-08-29T00:00:00",
//                 noOfInstalments: 12,
//                 organizationId: 2
//             },
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           });

//         return response.data;
//     } catch (error) {
//         return error.response?.data || {
//             header: { code: 500, value: "Something went wrong" },
//         };
//     }
// };


export const PreviewInstallment = async (accountNo, advancePayment, firstInstallmentDate, numInstallments, projectId) => {
    let responseData;
    try {
        const token = Cookies.get("accessToken");

        const response = await fetch(`${BASE_URL}api/v1/instalment-plan/web/preview?accountNo=${accountNo}&advanceAmount=${advancePayment}&firstInstalmentDate=${firstInstallmentDate}&noOfInstalments=${numInstallments}&projectId=${projectId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        responseData = await response.json();
    } catch (error) {
        throw new Error(`Error submitting form: ${error.message}`);
    }
console.log(responseData)
    if (responseData.header.code === 600) {
        return responseData;
    } else {
        toast.error(responseData.body.value);
    }
};

// Dummy success & error handlers
const handleSuccess = (data) => {
    console.log("Success:", data);
};

const handleError = (error) => {
    console.error("Error:", error);
};

export const CreateMultipleRc = async (payload) => {
    try {
        const token = Cookies.get("accessToken");

        const response = await axios.post(
            `${BASE_URL}api/v1/task/create-bulk-rc`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                responseType: "blob",
            }
        );
        const contentType = response.headers["content-type"];

        if (contentType.includes("application/json")) {
            // ✅ Convert Blob to JSON (if API returned JSON)
            const text = await response.data.text();
            return JSON.parse(text);
        }

        const blob = new Blob([response.data], { type: response.headers["content-type"] });
        console.log('blob: ', blob);

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        const contentDisposition = response.headers["content-disposition"];
        let fileName = "errorAccountList.xlsx";

        if (contentDisposition) {
            const matches = contentDisposition(/filename="?([^"]+)"?/);
            if (matches?.length > 1) {
                fileName = matches[1];
            }
        }

        link.download = fileName;
        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
        return null;
    } catch (error) {
        console.error("API Error:", error.response?.data || error.message);
        throw new Error(`Error submitting form: ${error.response?.data?.message || error.message}`);
    }
};

export const CreateMultipleRcWithOrg = async (payload) => {
    try {
        const token = Cookies.get("accessToken");

        const response = await axios.post(
            `${BASE_URL}api/v1/task/create-bulk-rc`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                responseType: "blob",
            }
        );
        const contentType = response.headers["content-type"];

        if (contentType.includes("application/json")) {
            // ✅ Convert Blob to JSON (if API returned JSON)
            const text = await response.data.text();
            return JSON.parse(text);
        }

        const blob = new Blob([response.data], { type: response.headers["content-type"] });
        console.log('blob: ', blob);

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        const contentDisposition = response.headers["content-disposition"];
        let fileName = "errorAccountList.xlsx";

        if (contentDisposition) {
            const matches = contentDisposition(/filename="?([^"]+)"?/);
            if (matches?.length > 1) {
                fileName = matches[1];
            }
        }

        link.download = fileName;
        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
        return null;
    } catch (error) {
        console.error("API Error:", error.response?.data || error.message);
        throw new Error(`Error submitting form: ${error.response?.data?.message || error.message}`);
    }
};
